document.querySelectorAll('.scrolldown-button button').forEach(button => {
    button.addEventListener('click', function() {
      // Lấy phần tử chứa button
      const currentSection = this.closest('section');
  
      if (currentSection) {
        // Tìm section tiếp theo
        let nextSection = currentSection.nextElementSibling;
  
        // Bỏ qua các phần tử không phải section
        while (nextSection && !nextSection.classList.contains('section')) {
          nextSection = nextSection.nextElementSibling;
        }
  
        if (nextSection) {
            nextSection.scrollIntoView({ behavior: 'smooth' });
        } else {
          console.error('Không có section tiếp theo.');
        }
      }
    });
  });
  